<template>
  <div class="container-fluid p-2" style="background-color:#ecf0f5;">
    <div class="container-sm w-50" style="background-color:whitesmoke;">
      <alert-area :errors="errors" v-on:close="errors = []"/>
      <div class="row">
        <b-card class="w-100">
          <template v-slot:header>
            <h6 class="mb-0">ユーザー管理（パスワードを入力してください）</h6>
          </template>
          <div class="container-fluid">
            <div class="row py-2">
              <div class="col d-flex align-items-center requier-col"></div>
              <div class="col d-flex align-items-center label-col"><label class="mb-0">Mail</label></div>
              <div class="col d-flex align-items-center input-col">
                <span>{{ teacher.login_id }}</span>
              </div>
            </div>
            <hr class="m-1"/>
            <div class="row py-2">
              <div class="col d-flex align-items-center requier-col">
                <h5 class="m-0"><b-badge variant="secondary">必須</b-badge></h5>
              </div>
              <div class="col d-flex align-items-center label-col"><label class="mb-0">パスワード</label></div>
              <div class="col d-flex align-items-center input-col">
                <b-form-input :type="'password'" v-model="teacher.password" id="password_check"/>
              </div>
            </div>
            <div class="row">
              <div class="col d-flex align-items-center requier-col"></div>
              <div class="col d-flex align-items-center input-col">
                <label class="mb-0" style="color:#AAAAAA;">フォーマット ： 英数字それぞれ1文字以上含む8〜100文字の半角文字</label>
              </div>
            </div>
            <hr class="m-1"/>
            <div class="row py-2">
              <div class="col d-flex align-items-center requier-col">
                <h5 class="m-0"><b-badge variant="secondary">必須</b-badge></h5>
              </div>
              <div class="col d-flex align-items-center label-col"><label class="mb-0">再入力</label></div>
              <div class="col d-flex align-items-center input-col">
                <b-form-input :type="'password'" v-model="teacher.password_confirmation" id="password_confirmation_check"/>
              </div>
            </div>
            <div class="row py-2">
              <div class="col d-flex align-items-center requier-col"></div>
              <div class="col d-flex align-items-center label-col"></div>
              <div class="col d-flex align-items-center">
                <b-form-checkbox @change="password_show"/>
                <span>パスワードを表示する</span>
              </div>
            </div>
            <hr class="m-1"/>
            <div class="row py-2">
              <div class="col d-flex align-items-center requier-col"></div>
              <div class="col d-flex align-items-center label-col"><label class="mb-0">ユーザー名</label></div>
              <div class="col d-flex align-items-center input-col">
                <b-form-input v-model="teacher.name"/>
              </div>
            </div>
            <!-- <hr class="m-1"/>
            <div class="row py-2">
              <div class="col d-flex align-items-center requier-col"></div>
              <div class="col d-flex align-items-center label-col"><label class="mb-0">担当教科</label></div>
              <div class="col d-flex align-items-center input-col">
                <b-form-radio-group v-model="teacher.curriculum_id">
                  <b-form-radio v-for="(curriculum, idx) in $store.getters.getComboboxCurriculums(false)" :key="idx"
                    v-bind:value="curriculum.value" v-bind:disabled="!isAdmin">{{ curriculum.text }}</b-form-radio>
                </b-form-radio-group>
              </div>
            </div> -->
            <hr class="m-1"/>
            <div class="row py-2">
              <div class="col d-flex align-items-center requier-col"></div>
              <div class="col d-flex align-items-center label-col"><label class="mb-0">生年月日</label></div>
              <div class="col d-flex align-items-center input-col">
                <b-form-input :type="'date'" v-model="teacher.birthday"/>
              </div>
            </div>
            <hr class="m-1"/>
            <div class="row">
              <div class="col d-flex align-items-center">
                <b-button onclick="window.history.back();" style="width:100px;">キャンセル</b-button>
              </div>
              <div class="col-md-auto d-flex align-items-center">
                <b-button @click="entryClick()" variant="primary" style="width:100px;">登録</b-button>
              </div>
            </div>
          </div>
        </b-card>
      </div>
    </div>
  </div>
</template>>

<script>
import Vue from 'vue'
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import AlertArea from "../../components/AlertArea";

export default Vue.extend({
  components: {
    "alert-area": AlertArea,
  },
  data() {
    return {
      teacher: {
        login_id: "",
        password: "",
        password_confirmation: "",
        name: "",
        curriculum_id: "",
        birthday: "",
      },
      errors: [],
      isShowPassword: false,
    }
  },
  computed: {
    isAdmin() {
      return this.$store.state.currentUser.role == Common.RoleEnum.Admin || this.$store.state.currentUser.role == Common.RoleEnum.Teacher1;
    },
  },
  async created() {
    // ユーザー情報をapiから取得
    await http.get(`/api/user_edit?id=${this.$store.state.currentUser.id}`).then(response => {
      var teacher = response.data.teacher;
      this.teacher.login_id = teacher.login_id;
      this.teacher.name = teacher.name;
      this.teacher.curriculum_id = teacher.curriculum_id;
      this.teacher.birthday = Common.formatDate(teacher.birthday, 'YYYY-MM-DD');
    })
    .catch(error=>{
      // 後続処理不能のため一覧に戻る
      if (error.response.status == 422) {
        alert(`ユーザー情報の取得処理に失敗しました。前の画面に戻ります。\n${error.response.data.errors[0]}`);
      } else {
        alert(`ユーザー情報の取得処理に失敗しました。前の画面に戻ります。`);
      }
      window.history.back();
    });

    if (this.$store.state.currentUser.login_count == 1) {
      alert(`${this.teacher.name}先生、ありがとうございます。パスワードを登録してください`);
    }
  },
  methods: {
    // 登録ボタン押下
    async entryClick() {

      if (!this.validate() || !window.confirm("教師情報を更新します。よろしいですか？")) {
        return;
      }

      this.$store.dispatch("showOverlay");
      this.errors = [];
      await http.patch(`/api/user_edit/${this.$store.state.currentUser.id}`, {teacher: this.teacher}).then(response => {
        alert("教師情報の変更が完了しました。");

        const defaultSheetType = this.$store.state.defaultSheetType;

        this.$router.push('/teacher_site/sheet_list').catch(err => {});
      })
      .catch(error=>{
        if (error.response.status == 422) {
          this.errors = error.response.data.errors;
        } else {
          this.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      this.$store.dispatch("hideOverlay");
    },
    // バリデーション
    validate() {
      this.errors = [];

      var regex = new RegExp(/^(?=.*?[a-z])(?=.*?\d)[a-z\d]{8,100}$/i);
      if (!regex.test(this.teacher.password)) {
        this.errors.push("パスワードのフォーマットを確認してください。");
      }
      
      if (this.teacher.password != this.teacher.password_confirmation) {
        this.errors.push("パスワードが一致しません。");
      }

      return this.errors.length == 0;
    },
    password_show() {
      if (this.isShowPassword) {
        document.getElementById('password_check').type = "password";
        document.getElementById('password_confirmation_check').type = "password";
        this.isShowPassword = false;
      } else {
        document.getElementById('password_check').type = "text";
        document.getElementById('password_confirmation_check').type = "text";
        this.isShowPassword = true;
      }
    },
  },
})
</script>

<style lang="scss" scoped>
.requier-col {
  max-width: 90px !important;
  padding-left: 40px !important;
}
.label-col {
  max-width: 100px !important;
}
.input-col {
  padding-right: 40px !important;
}
.card-body {
  padding: 0px 10px 15px 10px !important;
}
</style>